import { GuidelineCategories } from 'consts/hiToolsConsts'
import { useSelector } from 'react-redux'

/**
 * @param {{
 *   applianceIndex: number | null,
 *   scanPairId: string | null
 * }} params - Scan metadata used for treatment progress checks.
 *
 * @returns {{
 *   lastAlignerReached: boolean,
 *   IPRAlignerReached: boolean
 * }}
 */
export default ({ applianceIndex, scanPairId }) => {
  const { treatment } = useSelector(state => state.treatmentReducer)
  const { data: patientBriefData } = useSelector(state => state.patientsReducer.patientBrief)

  const latestPatientBrief = {
    ...patientBriefData?.[0],
    categories: JSON.parse(patientBriefData?.[0]?.categories || '{}')
  }

  const isAlignersScan = !!scanPairId
  const totalApplianceIndex = treatment?.totalApplianceNumber
  const IPRCategory = latestPatientBrief?.categories?.[GuidelineCategories.IPR]

  const IPRAlignerReached =
    isAlignersScan && IPRCategory?.isEnabled && Number(IPRCategory?.items?.alignerNumberReached) === applianceIndex

  const lastAlignerReached = isAlignersScan && totalApplianceIndex === applianceIndex

  return { lastAlignerReached, IPRAlignerReached }
}
